import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('profile', 'getProvider');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'circle_of_care_providers',
    {
      type: 'payload',
      selector: ['id'],
    },
  ],
});
export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/profiles/get-provider.js